import React, { Component } from 'react';
import { t } from 'i18next';

// นำเข้าไฟล์รูปภาพตามโครงสร้างพาธเดิมของคุณ
import ShotM1 from '../../assets/images/image-guide/01.jpeg';
import ShotM2 from '../../assets/images/image-guide/02.jpeg';
import ShotM3 from '../../assets/images/image-guide/03.jpeg';
import ShotM4 from '../../assets/images/image-guide/04.jpeg';
import ShotM5 from '../../assets/images/image-guide/05.jpeg';
import ShotM6 from '../../assets/images/image-guide/06.jpeg';
import ShotC7 from '../../assets/images/image-guide/07.png';
import ShotC8 from '../../assets/images/image-guide/08.png';
import ShotC9 from '../../assets/images/image-guide/09.png';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

class PushbulletGuide extends Component {
    render() {
        // --- สไตล์ CSS ทั้งหมดในรูปแบบวัตถุ JavaScript ---
        const styles = {
            global: {
                backgroundColor: '#eef3ef',
                color: '#16241c',
                fontFamily: '"IBM Plex Sans Thai", system-ui, sans-serif',
                fontSize: '16.5px',
                lineHeight: '1.65',
                margin: 0,
                padding: 0,
                boxSizing: 'border-box',
                width: '100%'
            },
            wrap: {
                maxWidth: '980px',
                margin: '0 auto',
                padding: '0 22px',
                boxSizing: 'border-box'
            },
            hero: {
                position: 'relative',
                overflow: 'hidden',
                background: 'radial-gradient(1200px 420px at 78% -12%, rgba(47,168,102,.20), transparent 60%), linear-gradient(180deg,#102b1d 0%, #0d2318 100%)',
                color: '#eaf3ec',
                borderBottomLeftRadius: '34px',
                borderBottomRightRadius: '34px'
            },
            heroWrap: {
                padding: '30px 22px 46px'
            },
            brandbar: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '16px',
                paddingBottom: '28px',
                flexWrap: 'wrap'
            },
            lockup: {
                display: 'flex',
                alignItems: 'center',
                gap: '14px',
                fontFamily: '"Kanit", sans-serif',
                fontWeight: 600
            },
            pbMark: {
                width: '42px',
                height: '42px',
                borderRadius: '11px',
                background: 'linear-gradient(150deg,#41c178,#239256)',
                display: 'grid',
                placeItems: 'center',
                boxShadow: '0 8px 20px -8px rgba(0,0,0,.5)'
            },
            x: {
                opacity: 0.5,
                fontWeight: 400,
                fontSize: '18px',
                margin: '0 2px'
            },
            peMark: {
                fontFamily: '"Kanit", sans-serif',
                fontWeight: 600,
                fontSize: '20px',
                letterSpacing: '.2px',
                background: 'linear-gradient(180deg,#fff,#cfe6d6)',
                WebkitBackgroundClip: 'text',
                backgroundClip: 'text',
                color: 'transparent'
            },
            stepsChip: {
                fontSize: '13px',
                color: '#a9c6b4',
                background: 'rgba(255,255,255,.07)',
                border: '1px solid rgba(255,255,255,.12)',
                padding: '6px 13px',
                borderRadius: '999px'
            },
            eyebrow: {
                fontSize: '13.5px',
                letterSpacing: '.14em',
                textTransform: 'uppercase',
                color: '#7fc69b',
                fontWeight: 600,
                fontFamily: '"Kanit", sans-serif'
            },
            h1: {
                fontFamily: '"Kanit", sans-serif',
                fontSize: 'clamp(30px, 5.4vw, 50px)',
                fontWeight: 700,
                margin: '14px 0 12px',
                letterSpacing: '-.5px',
                lineHeight: '1.18',
                color: '#fff'
            },
            hl: {
                color: '#5fd591'
            },
            lead: {
                maxWidth: '640px',
                color: '#bcd4c4',
                fontSize: '17px',
                margin: '0 0 26px'
            },
            meta: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: '10px'
            },
            tag: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: '14px',
                color: '#d7e8dd',
                background: 'rgba(255,255,255,.06)',
                border: '1px solid rgba(255,255,255,.12)',
                padding: '8px 14px',
                borderRadius: '999px'
            },
            need: {
                marginTop: '-30px',
                position: 'relative',
                zIndex: 2
            },
            needCard: {
                backgroundColor: '#ffffff',
                border: '1px solid #dde6e0',
                borderRadius: '18px',
                boxShadow: '0 1px 2px rgba(22,36,28,.05), 0 18px 40px -24px rgba(22,36,28,.28)',
                padding: '22px 24px',
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
                gap: '18px'
            },
            needCardH3: {
                fontFamily: '"Kanit", sans-serif',
                fontSize: '13px',
                letterSpacing: '.1em',
                textTransform: 'uppercase',
                color: '#56655c',
                fontWeight: 600,
                gridColumn: '1 / -1',
                margin: '0 0 -4px 0'
            },
            needItem: {
                display: 'flex',
                gap: '12px',
                alignItems: 'flex-start'
            },
            needItemIc: {
                flex: '0 0 auto',
                width: '38px',
                height: '38px',
                borderRadius: '10px',
                backgroundColor: '#e3f2ea',
                color: '#1c7a47',
                display: 'grid',
                placeItems: 'center'
            },
            needItemB: {
                fontFamily: '"Kanit", sans-serif',
                fontWeight: 500,
                display: 'block',
                fontSize: '15.5px'
            },
            needItemSpan: {
                fontSize: '13.5px',
                color: '#56655c'
            },
            phase: {
                margin: '54px 0 6px'
            },
            pillMobile: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: '9px',
                fontFamily: '"Kanit", sans-serif',
                fontWeight: 600,
                fontSize: '13.5px',
                padding: '7px 15px',
                borderRadius: '999px',
                backgroundColor: '#e3f2ea',
                color: '#1c7a47'
            },
            pillComputer: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: '9px',
                fontFamily: '"Kanit", sans-serif',
                fontWeight: 600,
                fontSize: '13.5px',
                padding: '7px 15px',
                borderRadius: '999px',
                backgroundColor: '#e0efee',
                color: '#2b7d7a'
            },
            phaseH2: {
                fontFamily: '"Kanit", sans-serif',
                fontSize: 'clamp(24px, 4vw, 34px)',
                fontWeight: 700,
                margin: '14px 0 6px',
                lineHeight: '1.18'
            },
            phaseP: {
                color: '#56655c',
                margin: 0,
                maxWidth: '620px'
            },
            flow: {
                position: 'relative',
                marginTop: '26px',
                paddingLeft: '6px'
            },
            step: {
                position: 'relative',
                display: 'flex',
                gap: '16px',
                paddingBottom: '30px'
            },
            rail: {
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                flex: '0 0 44px'
            },
            nodeMobile: {
                width: '44px',
                height: '44px',
                borderRadius: '50%',
                display: 'grid',
                placeItems: 'center',
                fontFamily: '"Kanit", sans-serif',
                fontWeight: 700,
                fontSize: '19px',
                color: '#fff',
                position: 'relative',
                zIndex: 2,
                boxShadow: '0 6px 14px -6px rgba(28,122,71,.6)',
                background: 'linear-gradient(160deg,#37b873,#1c7a47)'
            },
            nodeComputer: {
                width: '44px',
                height: '44px',
                borderRadius: '50%',
                display: 'grid',
                placeItems: 'center',
                fontFamily: '"Kanit", sans-serif',
                fontWeight: 700,
                fontSize: '19px',
                color: '#fff',
                position: 'relative',
                zIndex: 2,
                boxShadow: '0 6px 14px -6px rgba(43,125,122,.6)',
                background: 'linear-gradient(160deg,#37a09c,#2b7d7a)'
            },
            railLine: {
                position: 'absolute',
                left: '21px',
                top: '46px',
                bottom: '-30px',
                width: '2px',
                backgroundColor: '#dde6e0',
                zIndex: 1
            },
            card: {
                flex: 1,
                backgroundColor: '#ffffff',
                border: '1px solid #dde6e0',
                borderRadius: '18px',
                boxShadow: '0 1px 2px rgba(22,36,28,.05), 0 18px 40px -24px rgba(22,36,28,.28)',
                padding: '20px 22px',
                display: 'flex',
                flexWrap: 'wrap',
                gap: '22px',
                alignItems: 'center',
                overflow: 'hidden'
            },
            cardBody: {
                flex: '1 1',
                minWidth: 0
            },
            cardH3: {
                fontFamily: '"Kanit", sans-serif',
                fontSize: '19.5px',
                margin: '0 0 7px 0',
                lineHeight: '1.18'
            },
            cardP: {
                margin: 0,
                color: '#56655c',
                fontSize: '15.5px'
            },
            tipMobile: {
                marginTop: '12px',
                fontSize: '13.5px',
                color: '#1c7a47',
                backgroundColor: '#e3f2ea',
                borderRadius: '10px',
                padding: '8px 12px',
                display: 'inline-flex',
                gap: '8px',
                alignItems: 'flex-start'
            },
            tipComputer: {
                marginTop: '12px',
                fontSize: '13.5px',
                color: '#2b7d7a',
                backgroundColor: '#e0efee',
                borderRadius: '10px',
                padding: '8px 12px',
                display: 'inline-flex',
                gap: '8px',
                alignItems: 'flex-start'
            },
            kbd: {
                fontFamily: '"Kanit", sans-serif',
                fontWeight: 500,
                backgroundColor: '#eef1ee',
                border: '1px solid #dde6e0',
                borderRadius: '7px',
                padding: '1px 8px',
                fontSize: '.92em',
                color: '#16241c',
                whiteSpace: 'nowrap'
            },
            media: {
                flex: '0 0 auto',
                margin: '0 auto'
            },
            phone: {
                width: '134px',
                backgroundColor: '#13171a',
                borderRadius: '22px',
                padding: '7px',
                boxShadow: '0 16px 34px -18px rgba(0,0,0,.55)',
                position: 'relative',
                boxSizing: 'border-box'
            },
            phoneNotch: {
                content: '""',
                position: 'absolute',
                top: '14px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '44px',
                height: '5px',
                borderRadius: '5px',
                backgroundColor: '#2c3236',
                zIndex: 3
            },
            shot: {
                width: '100%',
                borderRadius: '6px',
                display: 'block',
                height: 'auto'
            },
            shotPhone: {
                borderRadius: '18px',
                width: '100%',
                display: 'block',
                height: 'auto'
            },
            browser: {
                width: '100%',
                minWidth: '280px',
                maxWidth: '560px',
                borderRadius: '12px',
                overflow: 'hidden',
                border: '1px solid #dde6e0',
                boxShadow: '0 16px 34px -20px rgba(0,0,0,.4)',
                backgroundColor: '#fff'
            },
            browserBar: {
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '9px 12px',
                backgroundColor: '#2b2b2f'
            },
            dot: {
                width: '11px',
                height: '11px',
                borderRadius: '50%'
            },
            url: {
                flex: 1,
                marginLeft: '6px',
                backgroundColor: '#3c3c42',
                color: '#cfd2d6',
                fontSize: '12px',
                padding: '5px 12px',
                borderRadius: '7px',
                fontFamily: '"JetBrains Mono", monospace',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            },
            connect: {
                margin: '46px 0 8px',
                background: 'linear-gradient(165deg,#143a26,#0f2c1d)',
                color: '#eaf3ec',
                borderRadius: '26px',
                padding: '38px 30px',
                position: 'relative',
                overflow: 'hidden',
                boxSizing: 'border-box'
            },
            connectH2: {
                fontFamily: '"Kanit", sans-serif',
                fontSize: 'clamp(24px, 4vw, 32px)',
                fontWeight: 700,
                margin: '12px 0 10px',
                color: '#fff',
                lineHeight: '1.18'
            },
            connectP: {
                color: '#bcd4c4',
                maxWidth: '560px',
                margin: '0 0 22px 0'
            },
            keyDemo: {
                backgroundColor: 'rgba(255,255,255,.05)',
                border: '1px solid rgba(255,255,255,.14)',
                borderRadius: '14px',
                padding: '18px',
                maxWidth: '560px',
                boxSizing: 'border-box'
            },
            keyDemoLabel: {
                fontSize: '13px',
                color: '#9ec3ae',
                fontFamily: '"Kanit", sans-serif',
                fontWeight: 500,
                display: 'block',
                marginBottom: '8px'
            },
            keyField: {
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                backgroundColor: '#0c2014',
                border: '1.5px solid #2fa866',
                borderRadius: '10px',
                padding: '11px 14px'
            },
            mono: {
                fontFamily: '"JetBrains Mono", monospace',
                flex: 1,
                color: '#7ee2a6',
                fontSize: '13.5px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            },
            paste: {
                fontFamily: '"Kanit", sans-serif',
                fontWeight: 600,
                fontSize: '13px',
                backgroundColor: '#2fa866',
                color: '#06210f',
                borderRadius: '8px',
                padding: '6px 13px',
                whiteSpace: 'nowrap'
            },
            warn: {
                margin: '26px 0 0',
                backgroundColor: '#fbf0d8',
                border: '1px solid #ecd9a6',
                borderLeft: '5px solid #b97e12',
                borderRadius: '14px',
                padding: '18px 20px',
                display: 'flex',
                gap: '14px',
                boxSizing: 'border-box'
            },
            warnIc: {
                flex: '0 0 auto',
                width: '34px',
                height: '34px',
                borderRadius: '9px',
                backgroundColor: '#fff',
                color: '#8f6206',
                display: 'grid',
                placeItems: 'center',
                border: '1px solid #ecd9a6'
            },
            warnH3: {
                fontFamily: '"Kanit", sans-serif',
                fontWeight: 600,
                fontSize: '16px',
                color: '#8f6206',
                margin: '0 0 4px 0'
            },
            warnP: {
                margin: 0,
                fontSize: '14.5px',
                color: '#6b5417'
            },
            footer: {
                textAlign: 'center',
                color: '#56655c',
                fontSize: '13.5px',
                padding: '40px 22px 56px'
            },
            dotSep: {
                opacity: 0.5,
                margin: '0 8px'
            }
        };

        return (
            <div style={styles.global}>
                {/* ===================== HERO ===================== */}
                <header style={styles.hero}>
                    <div style={styles.wrap}>
                        <div style={styles.heroWrap}>
                            <div style={styles.brandbar}>
                                <div style={styles.lockup}>
                                    <span style={styles.pbMark} aria-hidden="true">
                                        <svg width="22" height="22" viewBox="0 0 24 24" fill="#fff">
                                            <rect x="5" y="5" width="4.2" height="14" rx="2.1" />
                                            <path d="M11.5 5h3.2a7 7 0 0 1 0 14h-3.2z" fill="none" stroke="#fff" stroke-width="3.1" />
                                        </svg>
                                    </span>
                                    <span>Pushbullet</span>
                                    <span style={styles.x}>×</span>
                                    <span style={styles.peMark}>Payeasy</span>
                                </div>
                                <span style={styles.stepsChip}>{t('pushbullet_guide.hero.chip')}</span>
                            </div>

                            <div style={styles.eyebrow}>{t('pushbullet_guide.hero.badge')}</div>
                            <h1 style={styles.h1}>
                                {t('pushbullet_guide.hero.title_1')} <span style={styles.hl}>Pushbullet</span><br />
                                {t('pushbullet_guide.hero.title_2')}
                            </h1>
                            <p style={styles.lead}>{t('pushbullet_guide.hero.desc')}</p>

                            <div style={styles.meta}>
                                <span style={styles.tag}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#7fc69b" stroke-width="2">
                                        <circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" />
                                    </svg>
                                    {t('pushbullet_guide.hero.tag_time')}
                                </span>
                                <span style={styles.tag}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#7fc69b" stroke-width="2">
                                        <rect x="6" y="2" width="12" height="20" rx="3" /><path d="M11 18h2" />
                                    </svg>
                                    {t('pushbullet_guide.hero.tag_device')}
                                </span>
                                <span style={styles.tag}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#7fc69b" stroke-width="2">
                                        <path d="M20 6 9 17l-5-5" />
                                    </svg>
                                    {t('pushbullet_guide.hero.tag_skill')}
                                </span>
                            </div>
                        </div>
                    </div>
                </header>

                <div style={styles.wrap}>
                    {/* ===================== สิ่งที่ต้องเตรียม ===================== */}
                    <section style={styles.need}>
                        <div style={styles.needCard}>
                            <h3 style={styles.needCardH3}>{t('pushbullet_guide.prep.title')}</h3>
                            <div style={styles.needItem}>
                                <span style={styles.needItemIc}>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <rect x="6" y="2" width="12" height="20" rx="3" /><path d="M11 18h2" />
                                    </svg>
                                </span>
                                <div>
                                    <b style={styles.needItemB}>{t('pushbullet_guide.prep.android')}</b>
                                    <span style={styles.needItemSpan}>{t('pushbullet_guide.prep.android_sub')}</span>
                                </div>
                            </div>
                            <div style={styles.needItem}>
                                <span style={styles.needItemIc}>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <rect x="3" y="4" width="18" height="13" rx="2" /><path d="M8 21h8M12 17v4" />
                                    </svg>
                                </span>
                                <div>
                                    <b style={styles.needItemB}>{t('pushbullet_guide.prep.pc')}</b>
                                    <span style={styles.needItemSpan}>{t('pushbullet_guide.prep.pc_sub')}</span>
                                </div>
                            </div>
                            <div style={styles.needItem}>
                                <span style={styles.needItemIc}>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 4-6 8-6s8 2 8 6" />
                                    </svg>
                                </span>
                                <div>
                                    <b style={styles.needItemB}>{t('pushbullet_guide.prep.google')}</b>
                                    <span style={styles.needItemSpan}>{t('pushbullet_guide.prep.google_sub')}</span>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* ===================== เฟส 1: มือถือ ===================== */}
                    <section style={styles.phase}>
                        <span style={styles.pillMobile}>
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                                <rect x="6" y="2" width="12" height="20" rx="3" /><path d="M11 18h2" />
                            </svg>
                            {t('pushbullet_guide.phase_1.badge')}
                        </span>
                        <h2 style={styles.phaseH2}>{t('pushbullet_guide.phase_1.title')}</h2>
                        <p style={styles.phaseP}>{t('pushbullet_guide.phase_1.desc')}</p>
                    </section>

                    <div style={styles.flow}>
                        {/* STEP 1 */}
                        <div style={styles.step}>
                            <div style={styles.rail}>
                                <div style={styles.nodeMobile}>1</div>
                                <div style={styles.railLine}></div>
                            </div>
                            <div style={styles.card}>
                                <div style={styles.cardBody}>
                                    <h3 style={styles.cardH3}>{t('pushbullet_guide.steps.s1.title')}</h3>
                                    <p style={styles.cardP}>
                                        {t('pushbullet_guide.steps.s1.desc_1')} <b>Google Play Store</b> {t('pushbullet_guide.steps.s1.desc_2')} <span style={styles.kbd}>Pushbullet</span> {t('pushbullet_guide.steps.s1.desc_3')} <span style={styles.kbd}>{t('pushbullet_guide.steps.s1.btn_install')}</span>
                                    </p>
                                </div>
                                <div style={styles.media}>
                                    <div style={styles.phone}>
                                        <div style={styles.phoneNotch}></div>
                                        <img src={ShotM1} alt="" style={styles.shotPhone} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* STEP 2 */}
                        <div style={styles.step}>
                            <div style={styles.rail}>
                                <div style={styles.nodeMobile}>2</div>
                                <div style={styles.railLine}></div>
                            </div>
                            <div style={styles.card}>
                                <div style={styles.cardBody}>
                                    <h3 style={styles.cardH3}>{t('pushbullet_guide.steps.s2.title')}</h3>
                                    <p style={styles.cardP}>
                                        {t('pushbullet_guide.steps.s2.desc_1')} <span style={styles.kbd}>{t('pushbullet_guide.steps.s2.btn_login')}</span> {t('pushbullet_guide.steps.s2.desc_2')}
                                    </p>
                                    <div style={styles.tipMobile}>
                                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                            <circle cx="12" cy="12" r="9" /><path d="M12 8v5M12 16h.01" />
                                        </svg>
                                        {t('pushbullet_guide.steps.s2.tip')}
                                    </div>
                                </div>
                                <div style={styles.media}>
                                    <div style={styles.phone}>
                                        <div style={styles.phoneNotch}></div>
                                        <img src={ShotM2} alt="" style={styles.shotPhone} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* STEP 3 */}
                        <div style={styles.step}>
                            <div style={styles.rail}>
                                <div style={styles.nodeMobile}>3</div>
                                <div style={styles.railLine}></div>
                            </div>
                            <div style={styles.card}>
                                <div style={styles.cardBody}>
                                    <h3 style={styles.cardH3}>{t('pushbullet_guide.steps.s3.title')}</h3>
                                    <p style={styles.cardP}>
                                        {t('pushbullet_guide.steps.s3.desc_1')} <span style={styles.kbd}>{t('pushbullet_guide.steps.s3.btn_enable')}</span> {t('pushbullet_guide.steps.s3.desc_2')}
                                    </p>
                                </div>
                                <div style={styles.media}>
                                    <div style={styles.phone}>
                                        <div style={styles.phoneNotch}></div>
                                        <img src={ShotM3} alt="" style={styles.shotPhone} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* STEP 4 */}
                        <div style={styles.step}>
                            <div style={styles.rail}>
                                <div style={styles.nodeMobile}>4</div>
                                <div style={styles.railLine}></div>
                            </div>
                            <div style={styles.card}>
                                <div style={styles.cardBody}>
                                    <h3 style={styles.cardH3}>{t('pushbullet_guide.steps.s4.title')}</h3>
                                    <p style={styles.cardP}>
                                        {t('pushbullet_guide.steps.s4.desc_1')} <b>Pushbullet</b> {t('pushbullet_guide.steps.s4.desc_2')} <b>{t('pushbullet_guide.steps.s4.desc_3')}</b>
                                    </p>
                                </div>
                                <div style={styles.media}>
                                    <div style={styles.phone}>
                                        <div style={styles.phoneNotch}></div>
                                        <img src={ShotM4} alt="" style={styles.shotPhone} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* STEP 5 */}
                        <div style={styles.step}>
                            <div style={styles.rail}>
                                <div style={styles.nodeMobile}>5</div>
                                <div style={styles.railLine}></div>
                            </div>
                            <div style={styles.card}>
                                <div style={styles.cardBody}>
                                    <h3 style={styles.cardH3}>{t('pushbullet_guide.steps.s5.title')}</h3>
                                    <p style={styles.cardP}>
                                        {t('pushbullet_guide.steps.s5.desc_1')} <span style={styles.kbd}>{t('pushbullet_guide.steps.s5.btn_allow')}</span> {t('pushbullet_guide.steps.s5.desc_2')}
                                    </p>
                                </div>
                                <div style={styles.media}>
                                    <div style={styles.phone}>
                                        <div style={styles.phoneNotch}></div>
                                        <img src={ShotM5} alt="" style={styles.shotPhone} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* STEP 6 */}
                        <div style={styles.step}>
                            <div style={styles.rail}>
                                <div style={styles.nodeMobile}>6</div>
                                {/* ลบ RailLine เส้นสุดท้ายออก */}
                            </div>
                            <div style={styles.card}>
                                <div style={styles.cardBody}>
                                    <h3 style={styles.cardH3}>{t('pushbullet_guide.steps.s6.title')}</h3>
                                    <p style={styles.cardP}>
                                        {t('pushbullet_guide.steps.s6.desc_1')} <b>{t('pushbullet_guide.steps.s6.win_title')}</b> {t('pushbullet_guide.steps.s6.desc_2')} <span style={styles.kbd}>{t('pushbullet_guide.steps.s6.btn_accept')}</span> {t('pushbullet_guide.steps.s6.desc_3')}
                                    </p>
                                </div>
                                <div style={styles.media}>
                                    <div style={styles.phone}>
                                        <div style={styles.phoneNotch}></div>
                                        <img src={ShotM6} alt="" style={styles.shotPhone} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ===================== เฟส 2: คอมพิวเตอร์ ===================== */}
                    <section style={styles.phase}>
                        <span style={styles.pillComputer}>
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                                <rect x="3" y="4" width="18" height="13" rx="2" /><path d="M8 21h8M12 17v4" />
                            </svg>
                            {t('pushbullet_guide.phase_2.badge')}
                        </span>
                        <h2 style={styles.phaseH2}>{t('pushbullet_guide.phase_2.title')}</h2>
                        <p style={styles.phaseP}>{t('pushbullet_guide.phase_2.desc')}</p>
                    </section>

                    <div style={styles.flow}>
                        {/* STEP 7 */}
                        <div style={styles.step}>
                            <div style={styles.rail}>
                                <div style={styles.nodeComputer}>7</div>
                                <div style={styles.railLine}></div>
                            </div>
                            <div style={{ ...styles.card, flexDirection: 'column', alignItems: 'flex-start' }}>
                                <div style={styles.cardBody}>
                                    <h3 style={styles.cardH3}>{t('pushbullet_guide.steps.s7.title')}</h3>
                                    <p style={styles.cardP}>
                                        {t('pushbullet_guide.steps.s7.desc_1')} <span style={styles.kbd}>pushbullet.com</span> {t('pushbullet_guide.steps.s7.desc_2')} <span style={styles.kbd}>{t('pushbullet_guide.steps.s7.menu_settings')}</span> {t('pushbullet_guide.steps.s7.desc_3')} <span style={styles.kbd}>{t('pushbullet_guide.steps.s7.menu_account')}</span>
                                    </p>
                                </div>
                                <div style={{ ...styles.media, width: '100%' }}>
                                    <div style={styles.browser}>
                                        <div style={styles.browserBar}>
                                            <span style={{ ...styles.dot, backgroundColor: '#ff5f57' }}></span>
                                            <span style={{ ...styles.dot, backgroundColor: '#febc2e' }}></span>
                                            <span style={{ ...styles.dot, backgroundColor: '#28c840' }}></span>
                                            <span style={styles.url}>pushbullet.com/#settings</span>
                                        </div>
                                        <img src={ShotC7} alt="" style={styles.shot} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* STEP 8 */}
                        <div style={styles.step}>
                            <div style={styles.rail}>
                                <div style={styles.nodeComputer}>8</div>
                                <div style={styles.railLine}></div>
                            </div>
                            <div style={{ ...styles.card, flexDirection: 'column', alignItems: 'flex-start' }}>
                                <div style={styles.cardBody}>
                                    <h3 style={styles.cardH3}>{t('pushbullet_guide.steps.s8.title')}</h3>
                                    <p style={styles.cardP}>
                                        {t('pushbullet_guide.steps.s8.desc_1')} <b>Access Tokens</b> {t('pushbullet_guide.steps.s8.desc_2')} <span style={styles.kbd}>{t('pushbullet_guide.steps.s8.btn_create')}</span>
                                    </p>
                                </div>
                                <div style={{ ...styles.media, width: '100%' }}>
                                    <div style={styles.browser}>
                                        <div style={styles.browserBar}>
                                            <span style={{ ...styles.dot, backgroundColor: '#ff5f57' }}></span>
                                            <span style={{ ...styles.dot, backgroundColor: '#febc2e' }}></span>
                                            <span style={{ ...styles.dot, backgroundColor: '#28c840' }}></span>
                                            <span style={styles.url}>pushbullet.com/#settings</span>
                                        </div>
                                        <img src={ShotC8} alt="" style={styles.shot} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* STEP 9 */}
                        <div style={styles.step}>
                            <div style={styles.rail}>
                                <div style={styles.nodeComputer}>9</div>
                                {/* ลบ RailLine ตัวสุดท้ายออก */}
                            </div>
                            <div style={{ ...styles.card, flexDirection: 'column', alignItems: 'flex-start' }}>
                                <div style={styles.cardBody}>
                                    <h3 style={styles.cardH3}>{t('pushbullet_guide.steps.s9.title')}</h3>
                                    <p style={styles.cardP}>
                                        {t('pushbullet_guide.steps.s9.desc_1')} <b>{t('pushbullet_guide.steps.s9.action_copy')}</b> {t('pushbullet_guide.steps.s9.desc_2')}
                                    </p>
                                    <div style={styles.tipComputer}>
                                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                            <rect x="9" y="9" width="11" height="11" rx="2" /><path d="M5 15V5a2 2 0 0 1 2-2h10" />
                                        </svg>
                                        {t('pushbullet_guide.steps.s9.tip')}
                                    </div>
                                </div>
                                <div style={{ ...styles.media, width: '100%' }}>
                                    <div style={styles.browser}>
                                        <div style={styles.browserBar}>
                                            <span style={{ ...styles.dot, backgroundColor: '#ff5f57' }}></span>
                                            <span style={{ ...styles.dot, backgroundColor: '#febc2e' }}></span>
                                            <span style={{ ...styles.dot, backgroundColor: '#28c840' }}></span>
                                            <span style={styles.url}>pushbullet.com/#settings</span>
                                        </div>
                                        <img src={ShotC9} alt="" style={styles.shot} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ===================== ขั้นสุดท้าย: วางใน Payeasy ===================== */}
                    <section style={styles.connect}>
                        <div style={styles.eyebrow}>{t('pushbullet_guide.final.badge')}</div>
                        <h2 style={styles.connectH2}>{t('pushbullet_guide.final.title')}</h2>
                        <p style={styles.connectP}>
                            {t('pushbullet_guide.final.desc_1')} <b>Key</b> {t('pushbullet_guide.final.desc_2')}
                        </p>
                        <div style={styles.keyDemo}>
                            <label style={styles.keyDemoLabel}>{t('pushbullet_guide.final.field_label')}</label>
                            <div style={styles.keyField}>
                                <span style={styles.mono}>o.•••••••••••••••••••••••••••••</span>
                                <span style={styles.paste}>{t('pushbullet_guide.final.btn_paste')}</span>
                            </div>
                        </div>
                    </section>

                    {/* ===================== คำเตือนความปลอดภัย ===================== */}
                    <div style={styles.warn}>
                        <span style={styles.warnIc}>
                            <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M12 3 2 20h20z" /><path d="M12 9v5M12 17h.01" />
                            </svg>
                        </span>
                        <div>
                            <h3 style={styles.warnH3}>{t('pushbullet_guide.warn.title')}</h3>
                            <p style={styles.warnP}>
                                {t('pushbullet_guide.warn.desc_1')} <span style={styles.kbd}>{t('pushbullet_guide.warn.btn_reset')}</span> {t('pushbullet_guide.warn.desc_2')}
                            </p>
                        </div>
                    </div>
                </div>

                {/* ===================== FOOTER ===================== */}
                <footer style={styles.footer}>
                    {t('pushbullet_guide.footer.title')}
                    <span style={styles.dotSep}>•</span>
                    {t('pushbullet_guide.footer.desc')}
                </footer>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    // Map your state to props here if needed
});

const mapDispatchToProps = {
    // Define any actions you want to dispatch here
};
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PushbulletGuide));